import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { getMgbwPaginationOverrides } from "@tSurya/Common/Utilities/mgbwPaginationOverrides";
import loadCreditData from "@tSurya/Handlers/CreditMemoData";
import CustomApplicationState from "@tSurya/Store/Data/CustomApplicationState/CustomApplicationState";
import MyAccountThemeWrapper from "@tSurya/Utils/MyAccountThemeWrapper";
import React, { FC, useContext } from "react";
import { connect, ResolveThunks } from "react-redux";

interface OwnProps extends WidgetProps {}
const mapStateToProps = (state: CustomApplicationState) => {
    return {
        pagination: state.SURData.creditDataStore.pagination,
        serachedParameter: state.SURData.creditDataStore.searchparameter,
    };
};

const mapDispatchToProps = {
    loadCreditData,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface PaginationStyles {
    pagination?: PaginationPresentationProps;
}

export const paginationStyles: PaginationStyles = {
    pagination: getMgbwPaginationOverrides(),
};

const styles = paginationStyles;

const SurCreditMemoPagination: FC<Props> = ({ loadCreditData, pagination, serachedParameter }) => {
    if (!pagination) {
        return null;
    }

    const { totalItemCount, page, pageSize, pageSizeOptions } = pagination;

    if (totalItemCount === 0) {
        return null;
    }

    const changePage = (newPageIndex: number) => {
        loadCreditData({
            ...serachedParameter,
            page: newPageIndex,
        });
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);

        loadCreditData({
            ...serachedParameter,
            pageSize: newPageSize,
        });
    };

    return (
        <MyAccountThemeWrapper>
            <Pagination
                {...styles.pagination}
                resultsCount={totalItemCount}
                currentPage={page}
                resultsPerPage={pageSize}
                resultsPerPageOptions={pageSizeOptions}
                onChangePage={changePage}
                onChangeResultsPerPage={changeResultsPerPage}
                pageSizeCookie="CrediMemoData-PageSize"
            />
        </MyAccountThemeWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(SurCreditMemoPagination),
    definition: {
        displayName: "SurCreditMemoPagination",
        group: "Common",
    },
};

export default widgetModule;
